import { WordPressAPIURL,/* SiteAPIURL*/ } from './api';

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const { CLIENTBOOKS_URL } = publicRuntimeConfig;
export const SiteAPIURL = `${CLIENTBOOKS_URL}/cbapi/app.php/`;

export const SF_API = {
  TOKEN: '5cH3du13RApP01nTm3nT34',
  key: 'zHtj1b14s4n@t23Bu11f@5t',
};

export const WordPressAPI = {
  url: WordPressAPIURL,
  pages: `${WordPressAPIURL}wp/v2/pages`,
};

export const SiteAPI = {
  registerPartner: `${SiteAPIURL}website/register_partner`,
  checkUser: `${SiteAPIURL}website/api/check_user`,
  signUpUrl: `${CLIENTBOOKS_URL}/sso/#/sign_up`,
  credentials: {
    website: {
      client_id: 'website.web_5v7h3t1qwett4j6enzj0o81mv22jmr6whw2o07znwzuwtdae9x',
      client_secret: '3m639bgwndhjh32bk7vxgid7qyfert920ox75glkh0vh01b4ef',
    },
  },
};

